module.exports = __webpack_public_path__ + "assets/img/wscgq.adf1480e.png";